import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import ga4analyticsClient from '@/scopes/common/infrastructure/analytics/ga4analyticsClient'
import { useAccommodationContext } from '@/scopes/prices/components/AccommodationContext'
import {
  createBookingDraftSelector,
  isAccommodationAvailableSelector,
  pricesResponseSelector,
  selectedRoomInfosSelector,
} from '@/scopes/prices/components/selectors'
import { bookingDraftUseCases } from '@/scopes/prices/domain/useCases/bookingDraftUseCases'
import { bookingDraftApiClient } from '@/scopes/prices/infrastructure/booking-draft'
import { newPricesStore } from '@/scopes/prices/infrastructure/store'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { isClient } from '@/utilities'
import { Button, Modal, SpaceBetween, tk, Typography } from '@sunwebgroup/ui-components'
import * as React from 'react'

const { bookClickHandler, resetState } = bookingDraftUseCases({
  bookingDraftApiClient,
  analyticsClient: ga4analyticsClient,
  store: newPricesStore,
})

export function BookNowButton() {
  const intl = useIntl()
  const { prices } = usePricesSelector(pricesResponseSelector)
  const { selectedRoomInfos: selectedRooms } = usePricesSelector(selectedRoomInfosSelector)
  const { error: isError } = usePricesSelector(createBookingDraftSelector)
  const accommodationContext = useAccommodationContext()
  const { isFlightOnly } = usePricesSelector(isAccommodationAvailableSelector)
  const bookingStepsUrl = useCMSPageField('PDP.pricetable.bookingStepsUrl')
  const getUrl = () => {
    if (!isClient())
      return ''
    return window.location.href
  }
  const [openErrorModal, setOpenErrorModal] = React.useState(false)

  React.useEffect(() => {
    setOpenErrorModal(isError)
  }, [isError])

  const handleOnCreateBooking = async () =>
    bookClickHandler({
      prices,
      selectedRooms,
      accommodationContext,
      url: getUrl(),
      isFlightOnly,
      nextStepUrl: bookingStepsUrl,
    })

  const onCloseErrorModal = () => {
    setOpenErrorModal(false)
    resetState()
  }

  return (
    <>
      <Button onClick={handleOnCreateBooking} data-qa="book-now-button">
        {intl.formatMessage({ id: 'price_basket_price_breakdown_cta' })}
      </Button>
      <Modal.Root onClose={onCloseErrorModal} open={openErrorModal}>
        <Modal.Content $size="sm">
          <Modal.Header>
            <Modal.HeaderTitle text={intl.formatMessage({ id: 'price_basket_book_now_error_title' })} />
            <Modal.HeaderCloseButton />
          </Modal.Header>
          <Modal.Body>
            <SpaceBetween alignItems="center" direction="y" padding={tk('spacing_md')} spacing="">
              <Typography $variant="body-md" as="p">
                {intl.formatMessage({ id: 'price_basket_book_now_error_description' })}
              </Typography>
            </SpaceBetween>
          </Modal.Body>
          <Modal.Footer>
            <Button $hierarchy="primary" onClick={onCloseErrorModal}>
              {intl.formatMessage({ id: 'price_basket_book_now_error_button' })}
            </Button>
          </Modal.Footer>
        </Modal.Content>
      </Modal.Root>
    </>
  )
}
